import { render, staticRenderFns } from "./UserDeptAdmin.vue?vue&type=template&id=58509595&scoped=true&"
import script from "./UserDeptAdmin.vue?vue&type=script&lang=js&"
export * from "./UserDeptAdmin.vue?vue&type=script&lang=js&"
import style0 from "./UserDeptAdmin.vue?vue&type=style&index=0&id=58509595&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58509595",
  null
  
)

export default component.exports